import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

export const getWelcomeDisclaimerFooterStyles = (theme: Theme) =>
  StyleSheet.create({
    container: {
      marginTop: theme.spacing.lg,
      paddingHorizontal: theme.spacing.sm,
    },
    text: {
      fontSize: theme.typography.caption.fontSize,
      lineHeight: 18,
      color: theme.gray[500],
      textAlign: 'center',
    },
  });
